import React from "react";
import PropTypes from "prop-types";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import { StyledWrapper } from "./LinkItem.styled";

const LinkItem = (props) => {
  const { to, href, active, onClick, isInDropdown } = props;
  if (to) {
    return (
      <StyledWrapper active={active} isInDropdown={isInDropdown}>
        <Link
          color="inherit"
          underline="none"
          component={RouterLink}
          to={to}
          onClick={onClick}
          style={{ width: "100%" }}
        >
          {props.children}
        </Link>
      </StyledWrapper>
    );
  } else {
    return (
      <StyledWrapper>
        <Link
          color="inherit"
          underline="none"
          href={href}
          target="_blank"
          onClick={onClick}
          style={{ width: "100%" }}
        >
          {props.children}
        </Link>
      </StyledWrapper>
    );
  }
};

LinkItem.propTypes = {
  to: PropTypes.string,
};

export default LinkItem;
